import { LegalShell, LegalSection } from "@/components/LegalShell";

export default function Terms() {
  return (
    <LegalShell eyebrow="The fine print" title="Terms and Conditions" updated="October 2026" testId="terms-page">
      <LegalSection title="1. Who we are">
        <p>
          These Terms and Conditions govern the use of the EduPower Foundation website and
          participation in our programmes. EduPower Foundation is a Non-Profit Company (NPC
          registration number 2024/513680/0) based in Cape Town, Western Cape, South Africa.
        </p>
        <p>
          EduPower Foundation works in partnership with schools in the WCED Metro South Education
          District. We are an independent non-profit company: we are not part of, employed by, or
          formally endorsed by the Western Cape Education Department. Our programmes run in schools
          with the permission of each school's leadership.
        </p>
        <p>By using this website or taking part in our programmes, you accept these terms.</p>
      </LegalSection>

      <LegalSection title="2. Our programmes">
        <p>
          EduPower Foundation runs free English literacy clubs (Reading, Writing, Debate and Film &
          Media), the EduPower13 Grade 12 support programme, wellbeing sessions and teacher
          development workshops. Participation is voluntary and arranged through partner schools.
        </p>
        <p>
          Learners take part with the consent of a parent or guardian, obtained through their
          school. We expect all participants, volunteers and facilitators to treat one another with
          respect. We may pause or end participation where safety or conduct requires it.
        </p>
      </LegalSection>

      <LegalSection title="3. Children, photographs and media">
        <p>
          Many of our participants are minors. Photographs and videos of learners are published on
          this website and our social media only with consent obtained through the partner school
          and/or the learner's parent or guardian, in line with the Children's Act 38 of 2005 and
          the Protection of Personal Information Act 4 of 2013 (POPIA).
        </p>
        <p>
          We do not publish learner surnames or identifying personal details alongside photographs
          unless specific consent has been given.
        </p>
        <p>
          Any parent, guardian or school may ask us to remove any image or video at any time by
          emailing admin@edupowerfoundation.org. We will remove it promptly.
        </p>
      </LegalSection>

      <LegalSection title="4. Donations">
        <p>
          Donations made through this website are voluntary and are processed securely by PayFast.
          We never see or store your card or banking details.
        </p>
        <p>
          Donations are generally non-refundable. If you made a duplicate or mistaken donation,
          contact us at admin@edupowerfoundation.org within 14 days and we will review it.
        </p>
        <p>
          Donations fund learner transport, meals, books, stationery, tablets and resources,
          educational excursions, cultural experiences, study camps and the educator workshops that
          support our clubs.
        </p>
      </LegalSection>

      <LegalSection title="5. Likes, comments and sharing">
        <p>
          Visitors may like, comment on and share gallery moments without creating an account. By
          commenting you agree not to post anything offensive, harmful, unlawful, or that
          identifies or targets a learner. We may remove any comment at our discretion and without
          notice.
        </p>
      </LegalSection>

      <LegalSection title="6. Safeguarding">
        <p>
          The safety of learners comes first. Our facilitators and volunteers work under
          supervision and follow our child protection commitments. If you have any safeguarding
          concern about any EduPower Foundation activity, contact us immediately at
          admin@edupowerfoundation.org.
        </p>
      </LegalSection>

      <LegalSection title="7. Intellectual property">
        <p>
          The content of this website, including our name, logo and materials, belongs to EduPower
          Foundation unless stated otherwise. Learner writing, film and artwork remain the work of
          their creators and are shared here with consent.
        </p>
      </LegalSection>

      <LegalSection title="8. Third-party services">
        <p>
          We link to third-party services including PayFast, Instagram, Facebook and TikTok. We are
          not responsible for the content, terms or privacy practices of those services.
        </p>
      </LegalSection>

      <LegalSection title="9. Liability">
        <p>
          We work hard to keep this website accurate and available, but it is provided as is. To
          the extent permitted by South African law, EduPower Foundation is not liable for any loss
          arising from the use of this website.
        </p>
      </LegalSection>

      <LegalSection title="10. Changes and governing law">
        <p>
          We may update these terms from time to time and will note the date of the latest version
          above. These terms are governed by the laws of the Republic of South Africa.
        </p>
        <p>
          Questions about these terms can be sent to admin@edupowerfoundation.org.
        </p>
      </LegalSection>
    </LegalShell>
  );
}
